import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { decamelizeKeys } from 'humps';
import { adjust, startsWith, split, endsWith, compose, allPass, keys, partition, pick, fromPairs, map, toPairs, without, join } from 'ramda';
import { titleize } from '@peloton/text';

var decamelizeWithSpaces = function decamelizeWithSpaces(obj) {
  return decamelizeKeys(obj, {
    separator: ' '
  });
};

var renameKeys = function renameKeys(fn) {
  return compose(fromPairs, map(adjust(fn, 0)), toPairs);
};

export var toSegmentReadableKeys = compose(renameKeys(titleize), decamelizeWithSpaces);
/**
 * Creates an object of key/value pairs that are human readable for analytics consumption.
 * It will respect a special delimiter to ignore transformation and return keys as-is.
 *
 * @param {object} properties - The analytics properties to be transformed.
 * @param {string} [exactStart='['] - Delimiter that marks the start of a exact string (e.g. '[').
 * @param {string} [exactEnd=']'] - Delimiter that marks the end of a exact string (e.g. ']').
 */

export var toAnalyticsKeysWithOverrides = function toAnalyticsKeysWithOverrides(properties) {
  var exactStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '[';
  var exactEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ']';

  var _compose = compose(partition(isExactAnalyticsKey(exactStart, exactEnd)), keys)(properties),
      _compose2 = _slicedToArray(_compose, 2),
      exactKeys = _compose2[0],
      standardKeys = _compose2[1];

  return _objectSpread(_objectSpread({}, toSegmentReadableKeys(pick(standardKeys, properties))), toExactKeys(exactStart, exactEnd)(pick(exactKeys, properties)));
};

var isExactAnalyticsKey = function isExactAnalyticsKey(start, end) {
  return allPass([startsWith(start), endsWith(end)]);
};

var toAnalyticsString = function toAnalyticsString(start, end) {
  return compose(join(''), without([start, end]), split(''));
};

var toExactKeys = function toExactKeys(start, end) {
  return compose(fromPairs, map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var analyticsString = toAnalyticsString(start, end)(key);
    return [analyticsString, value];
  }), toPairs);
};